import { ProfileLocated } from 'common/enum/profile'

export default function translateRole(role?: string) {
  return ProfileLocated[role]
}
